/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import 'reflect-metadata'
import '@/entry/setupAppGenogram.js'
import {Vue, routerManager} from './importLight'

Vue.use(routerManager.router)

routerManager.router.isReady().then(() => {
	console.log("main.js: routerManager router is ready")
	setTimeout(() => {
		document.dispatchEvent(new Event('prerender-start'))
	}, 1000)
}).catch(error => console.error("routerManager.router.isReadygenogra error = ", error))

//we don't wait for the router to be ready to save start time for SEO. We don;t rely on router in genogram, so no issues here (unless we start to do so)
Vue.mount('#app')
